import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as AppStore } from '../assets/images/appstore.svg';
import { ReactComponent as PlayStore } from '../assets/images/googleplay.svg';
import { useDispatch, useSelector } from "react-redux";
import { getCurrentLocation, getallCities } from "../redux/cities/citiesSlice";
import "../styles/Rider.css";

const Rider = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const dispatch = useDispatch();
const [hoverIndex, setHoverIndex] = useState(null); // ✅ Track hover
  const isMobile = window.innerWidth <= 600;

  const { city, basePrice } = useSelector((state) => state.cities.currentLocation);
  const cc = useSelector((state) => state.cities.cities);
// console.log(cc);
// console.log(city);

// console.log(cc.some(c => c.name === city) ? basePrice.toFixed(2) :'9.95');


  useEffect(() => {
    dispatch(getCurrentLocation());
    dispatch(getallCities());
  }, [dispatch]);

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };



  const [activeDot, setActiveDot] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setActiveDot(prev => (prev + 1) % 3); // cycle through 0 → 1 → 2
  }, 3500); // 3 images, 12s total = 4s per image

  return () => clearInterval(interval); // clean up on unmount
}, []);


  const questions = [
    {
      question: "What is Berymo?",
      answer:
        "Berymo is the most affordable rideshare service that transports you anywhere in your city with a flat fee. Pick your destination on the app and only pay a $9.95 flat fee.",
    },
    {
      question: "How to request a ride with Berymo?",
      answer: (
        <ol className="faq-steps">
          <p>
            Open your app and enter your destination in the "Where are you going?"<br /><br />
            Tap "CONFIRM PICKUP LOCATION". You can change your pickup location by tapping the “search” icon.<br /><br />
            Tap “1” if you are riding alone. You’ll have the option to add a friend (max 2 people).<br /><br />
            To add a friend to the ride, tap “2”.
          </p>
        </ol>
      ),
    },
    {
      question: "How much does it cost to request the Berymo ",
      answer: (
        <p>
          Unlike other ridesharing companies, we don’t charge you per mile or minute. You will be charged a flat fee to ride anywhere in your city as long as your dropoff location is within an 8-mile radius of your pickup location.<br /><br />
          We charge $9.95 if you are requesting Berymo in your city.<br /><br />
          Fees may change based on your city and location.
        </p>
      )
    },
  ];

  const displayBasePrice = city ? basePrice.toFixed(2) : '9.95';

  return (
    <div>
      {/* Hero Section */}
      <div className="full-container">
        <div className="hero-sec">
          <div className="hero-text">
            <h1>Most affordable ride <br /> in your city</h1>
            <p>Anywhere in your city with flat fee</p>
            <a href="https://apps.apple.com/us/app/berymo-free-rides-to-places/id1440035720">
              <button className="ridees">Sign Up To Ride</button>
            </a>
          </div>
          <div className="all-images">
            <img src="/images/rider.jpg" alt="-jifjisof" className="hero-image" />
          </div>
        </div>

        {/* Why Ride */}
        <div className="berymo-containers">
          <h2>Why ride with Berymo</h2>
          <p className="berymo-subtexts">
            {city ? (
              <>
                Berymo is the most affordable rideshare service that transports you anywhere in <strong>{city}</strong> with a flat fee. 
                Pick your destination on the app and only pay a <strong>${displayBasePrice}</strong> flat fee.
              </>
            ) : (
              <>
                Berymo is the most affordable rideshare service that transports you anywhere in your city with a flat fee. 
                Pick your destination on the app and only pay a <strong>${displayBasePrice}</strong> flat fee.
              </>
            )}
          </p>

       


        <div className="berymo-grids">
          {[
            {
              img: "family",
              title: "Be there safe",
              text: "Pick your destination from the app. Check your driver’s information for a safe and hassle-free ride.",
            },
            {
              img: "cash",
              title: "Save money",
              text: "Why pay more when you can pay less? Pay only an $9.95 flat fee to ride anywhere in your city with Berymo.",
            },
            {
              img: "time",
              title: "Save time",
              text: "No more wasting time looking for transportation. Request a free ride with Berymo Places and get where you need to go easily.",
            },
            {
              img: "friends",
              title: "Enjoy with friends",
              text: "Ride with people going in the same direction. We pick the fastest route for your convenience.",
            },
            {
              img: "free",
              title: "Absolutely free",
              text: "Know exactly how much you'll pay before you even open the app. No headaches, no hidden fees.",
            },
            {
              img: "cars",
              title: "Return ride",
              text: "Pay a flat fee to ride anywhere in your city. No hidden fees—just savings.",
            },
          ].map((item, i) => (
            <div className="berymo-box" key={i}>
              <img src={`/images/${item.img}.png`} alt={item.img} className="icon" />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* How it Works */}
      <div className="work">
        <div className="works">
          <h4>HOW IT WORKS?</h4>
          <h3>Choose your destination</h3>
          <p>Choose your destination from the app for yourself. You will be able to pick a destination that is in 8 miles radius.</p>

          <h3>Get a ride in minutes</h3>
          <p>After requesting a ride, one of our drivers will pick you up from your current location and take you to your destination.</p>

          <h3>Enjoy your savings</h3>
          <p>Pay only a flat fee to ride anywhere in your city. No headaches, no hidden fees, just savings.</p>

         <div className="store-btn">
         <a href="https://apps.apple.com/us/app/berymo-free-rides-to-places/id1440035720" target="_blank" rel="noopener noreferrer">
        <AppStore />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.berymoflat" target="_blank" rel="noopener noreferrer">
        <PlayStore />
         </a>
        </div>
        </div>
<div className="how-image">
  <div className="phone-frame">
    <img src="/images/iphoneX.png" alt="Phone" className="phone-bg" />
    <div className="scroll-wrapper">
      <div className="carousel" id="carousel">
        <img src="/images/Theway.jpeg" alt="App UI" className="app-screen" />
        <img src="/images/Lake.jpeg" alt="App UI" className="app-screens" />
        <img src="/images/Jason.jpeg" alt="App UI" className="app-screenss" />
      </div>
    </div>
  <div className="dots">
  {[0, 1, 2].map((i) => (
    <span
      key={i}
      className={`dot ${activeDot === i ? "active" : ""}`}
    ></span>
  ))}
</div>

  </div>
</div>


      </div>

      {/* Driver Safety */}
      <div className="berymo-container">
        <h2>Verified drivers for safer rides</h2>
        <p className="berymo-subtext">
          At Berymo, we verify all of our drivers before they hit the road by running background checks, inspecting their vehicles, and reviewing their ratings.This flat fee will cover the cost of transportation and guarantee drivers are earning enough.
        </p>
        <div className="berymo-grid">
          {[
            {
              img: "security",
              title: "Background checks",
              text: "Drivers must provide their social security number upon signing up. Our third-party partners run national background checks before approval.",
            },
            {
              img: "file",
              title: "Zero tolerance policy",
              text: "Berymo enforces a zero tolerance drug and alcohol policy for all drivers. Riders can report concerns through the in-app feature.",
            },
            {
              img: "headphone",
              title: "Emergency calling",
              text: "In case of emergency, tap the Emergency button or call 911. We’ll notify local authorities immediately.",
            },
          ].map((item, i) => (
            <div className="berymo-box" key={i}>
              <img src={`/images/${item.img}.png`} alt={item.img} className="icon" />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
        <Link to="/safety" className="safety">Learn more about safety with Berymo →</Link>
      </div>
<div className="safety-images-section">
  <img
    src="/images/find-a-city.jpg"
    alt="Hero"
    className="safety-images"
  />
</div>
     {/* FAQ SECTION */}
<div
  style={{
    padding: isMobile ? "40px 15px" : "60px 0",
    backgroundColor: "#fff",
    fontFamily: "Helvetica, Arial, sans-serif",
  }}
>
  <h1
    style={{
      fontSize: isMobile ? "24px" : "26px",
      fontWeight: "bold",
      marginBottom: isMobile ? "25px" : "40px",
      textAlign: "left",
      color: "#000",
      lineHeight: isMobile ? "28px" : "32px",
      maxWidth: "1000px",
      margin: isMobile ? "0 auto" : "0 auto 40px",
    }}
  >
    {isMobile ? (
      <>
        Frequently asked
        <br />
        questions from our
        <br />
        rider
      </>
    ) : (
      "Frequently asked questions from our rider"
    )}
  </h1>

  <div
    style={{
      maxWidth: isMobile ? "100%" : "1000px",
      margin: "0 auto",
    }}
  >
    {questions.map((item, index) => (
      <div
        key={index}
        onClick={() => toggleQuestion(index)}
        onMouseEnter={() => setHoverIndex(index)}
        onMouseLeave={() => setHoverIndex(null)}
        style={{
          borderBottom: "1px solid #e0e0e0",
          padding: isMobile ? "18px 0" : "22px 0",
          cursor: "pointer",
        }}
      >
        {/* Question Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontSize: isMobile ? "16px" : "18px",
              fontWeight: "bold",
              color:
                activeIndex === index || hoverIndex === index
                  ? "#FD5C63"
                  : "#000",
              lineHeight: "22px",
              width: "90%",
            }}
          >
            {item.question}
          </span>

          <span
            style={{
              fontSize: isMobile ? "22px" : "24px",
              fontWeight: 300,
              color:
                activeIndex === index || hoverIndex === index
                  ? "#FD5C63"
                  : "#000",
            }}
          >
            {activeIndex === index ? "×" : "+"}
          </span>
        </div>

        {/* Answer Section */}
        <div
          style={{
            maxHeight: activeIndex === index ? "400px" : "0px",
            opacity: activeIndex === index ? 1 : 0,
            overflow: "hidden",
            transition: "max-height 0.4s ease, opacity 0.3s ease",
            fontSize: isMobile ? "14px" : "16px",
            lineHeight: "22px",
            color: "#444",
            paddingTop: activeIndex === index ? "10px" : "0px",
            textAlign: "left",
          }}
        >
          {item.answer}
        </div>
      </div>
    ))}
  </div>
</div>
{/* CTA SECTION */}
<div
  style={{
    backgroundColor: "#FEF4F5",
    clipPath: "polygon(0 7%, 100% 0, 100% 100%, 0% 100%)",
    padding: isMobile ? "120px 20px 20px" : "120px 20px 50px",
    textAlign: "center",
  }}
>
  <h1
    style={{
      fontSize: isMobile ? "20px" : "25px",
      marginBottom: isMobile ? "10px" : "17px",
      fontWeight: 700,
      lineHeight: isMobile ? "30px" : "42px",
      color: "#000",
    }}
  >
    Affordable rides are just tap away
  </h1>

  <p
    style={{
      fontSize: isMobile ? "14px" : "16px",
      color: "#555",
      lineHeight: isMobile ? "22px" : "26px",
      margin: 0,
    }}
  >
    Get affordable rides anywhere in your city and pay only $9.95 flat fee
  </p>

  {/* Button */}
  <a
    href="https://play.google.com/store/apps/details?id=com.berymoflat&pli=1"
    style={{ textDecoration: "none" }}
  >
    <button
      style={{
        backgroundColor: "#fd5c63",
        color: "#fff",
        border: "none",
        padding: isMobile ? "0.9rem 1.6rem" : "1rem 2.5rem",
        width: isMobile ? "53%" : "200px",
        cursor: "pointer",
        fontWeight: "bold",
        fontSize: isMobile ? "0.7rem" : "0.69rem",
        textTransform: "uppercase",
        textAlign: "center",
        fontFamily: "'Segoe UI', Arial, sans-serif",
        borderRadius: "5px",
        transition: "background-color 0.3s ease, transform 0.2s ease",
        marginTop: isMobile ? "24px" : "30px",
        marginBottom: isMobile ? "40px" : "60px",
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = "#474747";
        e.target.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = "#fd5c63";
        e.target.style.transform = "scaleX(1)";
      }}
    >
      Sign Up To Ride
    </button>
  </a>
</div>

    </div>    </div>
  );
};

export default Rider;
